/**
 * User utilities
 * @namespace UserUtils
 */

export default class UserUtils { 
    /**
     * Get user full name
     * @param {Object} user - User object
     */
    static getFullName(user) {
        console.log('useruser', user)
        if(!user) return; // prevent error if user is not defined
        const name = `${user.first_name || user?.user_firstname || ''} ${user.last_name || user?.user_lastname || ''}`.trim();

        if(name.trim()) return name

        return user?.display_name || ''
    }

    /**
     * Check if user is assigned to stake or ward
     * @param {Array} assignedWards - Assigned wards
     * @return {Boolean} - True if user is assigned to stake or ward
     */
    static isAssignedToStakeOrWard(assignedWards) {
        /**
         * slice assignedWards  by . and get the first part then check if has stake or ward word 
         */
        const assignedWardsDomain = assignedWards.map((item) => item.split('.')[0]) || [];
        console.log(assignedWards, 'assignedWardsDomain', assignedWardsDomain);
        const isAssignedToStake = assignedWardsDomain.some((item) => item.includes('stake'));

        return isAssignedToStake ? 'stake' : 'ward';
    }

    /** 
    * Get ward name
    * @param {String} siteDomain - Site domain
    * @param {Array} wards - Wards array
    * @return {String} - Ward name
    */
    static getWardName = (wards, site_domain) => {
        const ward = wards?.find(w => w.site_domain == site_domain)
        return ward?.header?.trim() || site_domain
    }
}